import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    emailjs
      .sendForm(
        'service_qj1hrw7',
        'template_siy0k8b',
        form.current,
        'F57g1A7NFWW6AeMro'
      )
      .then(
        () => {
          setStatus('Message sent successfully!');
          form.current.reset();
        },
        (error) => {
          setStatus(`Failed to send message: ${error.text}`);
        }
      );
  };

  return (
    <section className="contact-container">
      <div className="contact-content">
        <div className="form-container">
          <h2>Contact Me</h2>
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <div className="input-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="user_name" required />
            </div>
            <div className="input-group">
              <label htmlFor="phone">Phone</label>
              <input type="tel" id="phone" name="user_phone" required />
            </div>
            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="user_email" required />
            </div>
            <div className="input-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="5" required></textarea>
            </div>
            <button type="submit" className="cta-button">Send Message</button>
          </form>
          {status && <p className="status-message">{status}</p>}
        </div>
        <div className="image-container">
          <img
            src="https://www.shutterstock.com/image-vector/business-man-entrepreneur-suit-working-600nw-421282051.jpg"
            alt="Person working at a desk"
            className="contact-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;